import { Link, useNavigate } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND } from "@/lib/site";

export const Footer = () => {
  const navigate = useNavigate();
  const go = (to) => { navigate(to); window.scrollTo({ top: 0 }); };
  return (
    <footer data-testid="site-footer" className="bg-dc-bg border-t border-dc-border relative noise-overlay">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="dc-label mb-4">Talk to our commercial team</div>
            <p className="text-dc-text2 max-w-md leading-relaxed mb-8">
              Discuss bulk paper, cardboard, OCC, recovered-fibre supply, off-take or logistics partnerships.
            </p>
            <div className="space-y-3">
              <a href={BRAND.phoneHref} className="flex items-center gap-3 text-white hover:text-dc-accent transition-colors">
                <Phone size={16} className="text-dc-accent" /> <span className="font-mono">{BRAND.phone}</span>
              </a>
              <a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 text-white hover:text-dc-accent transition-colors">
                <Mail size={16} className="text-dc-accent" /> <span className="font-mono text-sm">{BRAND.email}</span>
              </a>
              <div className="flex items-center gap-3 text-dc-text2">
                <MapPin size={16} className="text-dc-accent" /> {BRAND.location}
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-widest text-dc-muted mb-4">Explore</div>
            <ul className="space-y-2.5 text-sm text-dc-text2">
              {[["For Businesses","/contact"],["Materials","/#materials"],["How It Works","/#how-it-works"],["Partners","/partners"]].map(([l,t]) => (
                <li key={l}><button className="hover:text-white transition-colors" onClick={() => t.startsWith("/#") ? go("/") : go(t)}>{l}</button></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-widest text-dc-muted mb-4">Company</div>
            <ul className="space-y-2.5 text-sm text-dc-text2">
              {[["About","/about"],["Compliance","/compliance"],["Contact","/contact"],["Privacy Policy","/compliance"],["Terms","/compliance"]].map(([l,t]) => (
                <li key={l}><button className="hover:text-white transition-colors" onClick={() => go(t)}>{l}</button></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-widest text-dc-muted mb-4">Registration</div>
            <div className="border border-dc-border p-4 bg-dc-surface">
              <div className="text-[11px] uppercase tracking-wider text-dc-text2">Upper Tier Waste Broker</div>
              <div className="font-mono text-dc-accent mt-1">{BRAND.eaReg}</div>
              <div className="text-[11px] text-dc-muted mt-1">Environment Agency Registered</div>
            </div>
          </div>
        </div>

        <div className="mt-20 mb-6 overflow-hidden">
          <div className="font-display text-[15vw] lg:text-[13vw] leading-none font-semibold tracking-tighter text-transparent" style={{ WebkitTextStroke: "1px #1F2937" }}>
            DES-CARTA
          </div>
        </div>

        <div className="border-t border-dc-border pt-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-dc-muted">
          <span>© {new Date().getFullYear()} DES-CARTA LTD. All rights reserved. Registered office: London, United Kingdom.</span>
          <span>Registered Upper Tier Waste Broker · Environment Agency · {BRAND.eaReg}</span>
        </div>
      </div>
    </footer>
  );
};
